import ResizeTextarea from 'react-textarea-autosize'
import { Textarea } from '@chakra-ui/react'

type AutoResizeTextareaProps = React.ComponentPropsWithRef<typeof Textarea>

export const AutoResizeTextarea = ({
  ref,
  ...props
}: AutoResizeTextareaProps) => {
  return (
    <Textarea
      minH="unset"
      overflow="hidden"
      w="100%"
      resize="none"
      ref={ref}
      minRows={1}
      as={ResizeTextarea}
      {...props}
    />
  )
}
